// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.AddEmoji = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.AddEmoji = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var AddEmoji = _exports.AddEmoji = function AddEmoji(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 21 21"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M14.192 8.734c0-.882-.463-1.528-1.091-1.528-.63 0-1.092.646-1.092 1.528s.463 1.528 1.092 1.528c.628 0 1.091-.646 1.091-1.528m-5.24 0c0-.882-.463-1.528-1.091-1.528-.63 0-1.092.646-1.092 1.528s.463 1.528 1.092 1.528c.628 0 1.091-.646 1.091-1.528m5.546 4.76a.654.654 0 1 0-1.04-.795 3.7 3.7 0 0 1-2.969 1.485 3.71 3.71 0 0 1-2.96-1.485.655.655 0 0 0-1.048.786 5.04 5.04 0 0 0 4.008 2.008 5.05 5.05 0 0 0 4.018-2.008z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.162 3.798a9.4 9.4 0 0 1 2.717 5.857c.037.431-.318.783-.75.783-.434 0-.78-.352-.824-.783a7.823 7.823 0 1 0-8.566 8.566c.43.044.782.39.782.823s-.351.788-.783.752A9.392 9.392 0 0 1 3.881 3.798a9.39 9.39 0 0 1 13.28 0m-.549.549.549-.549zM17.469 13.991c.376-.003.683.3.686.676l.044 5.647a.681.681 0 0 1-1.362.01l-.044-5.647a.68.68 0 0 1 .675-.686",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13.99 17.468a.68.68 0 0 1 .687-.676l5.647.045a.681.681 0 1 1-.01 1.362l-5.648-.045a.68.68 0 0 1-.675-.686",
      clipRule: "evenodd"
    }));
  };
});
